// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UserInfoSetting__main .grey {\n  background-color: #edeef1;\n  border-color: #edeef1;\n  color: #666;\n}\n.UserInfoSetting__main .blue {\n  background-color: #ecf5ff;\n  border-color: #ecf5ff;\n  color: #ecf5ff;\n}\n.UserInfoSetting__footer {\n  display: flex;\n  justify-content: flex-end;\n}", ""]);
// Exports
module.exports = exports;
